// src/location.ts
var isLocationSource = (value) => {
  if (typeof value !== "string") {
    return false;
  }
  return ["web", "mobile", "desktop"].includes(value);
};

export {
  isLocationSource
};
